import {ReactElement} from 'react'
import Amount from '../../../../../../Common/Amount'
import {SubscriptionStatistic} from '../../hooks/useSubscriptionStatistics'
import {useStyles} from './styles'

type PaidPerformanceAmountProps = {
  subscription: SubscriptionStatistic
  isDefaultDate: boolean
}

export const PaidPerformanceAmount = (props: PaidPerformanceAmountProps): ReactElement => {
  const {subscription, isDefaultDate} = props
  const {paidPerformanceFee, stoppedAt, currency} = subscription

  const classes = useStyles()

  const getFeeClassName = (): string => {
    if (paidPerformanceFee > 0) return classes.greenText
    if (isDefaultDate && stoppedAt == null) return classes.yellowText
    return classes.redText
  }

  return (
    <Amount
      value={paidPerformanceFee}
      currency={currency}
      locale='en-US'
      classes={{root: getFeeClassName()}}
    />
  )
}

